'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { SaveIcon } from 'lucide-react'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Button } from '@/components/ui/button'
import AddressForm from './address-form'
import { AddressType } from '@/types/address'

const FORM_ID = 'address-dialog-form'

type PropsType = {
  address?: AddressType
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess?: (address: AddressType) => void
}

const AddressDialog = ({ address, open, onOpenChange, onSuccess }: PropsType) => {
  const t = useTranslations()
  const isEditing = !!address
  const [isPending, setIsPending] = useState(false)

  const handleSuccess = (saved: AddressType) => {
    onOpenChange(false)
    onSuccess?.(saved)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{isEditing ? t('edit_address') : t('add_address')}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="min-h-0 flex-1" viewportClassName="max-h-[calc(90vh-9rem)]">
          <div className="px-5 pr-3 pb-5">
            <AddressForm address={address} formId={FORM_ID} onSuccess={handleSuccess} onPendingChange={setIsPending} />
          </div>
        </ScrollArea>
        <DialogFooter>
          <Button type="submit" form={FORM_ID} disabled={isPending}>
            <SaveIcon className="h-4 w-4" />
            {isPending ? t('saving') : t('save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default AddressDialog
